/* Stoned Crazy: banner slideshow — scroll-snap track, dots, arrows, optional autoplay. */
class SCBanners extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.sc-banners__track');
    this.slides = [...this.querySelectorAll('.sc-banners__slide')];
    this.dots = [...this.querySelectorAll('.sc-banners__dot')];
    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.querySelector('.sc-banners__arrow--prev')?.addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('.sc-banners__arrow--next')?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.index))));

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.index = this.slides.indexOf(entry.target);
            this.mark();
          }
        }
      },
      { root: this.track, threshold: 0.55 }
    );
    this.slides.forEach((s) => this.observer.observe(s));

    const seconds = Number(this.getAttribute('autoplay') || 0);
    if (seconds > 0 && !this.reduced) {
      this.start = () => {
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
      };
      this.stop = () => clearInterval(this.timer);
      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
      this.start();
    }
  }

  disconnectedCallback() {
    this.stop?.();
    this.observer?.disconnect();
  }

  go(next) {
    const count = this.slides.length;
    this.index = (next + count) % count;
    const slide = this.slides[this.index];
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
    this.mark();
  }

  mark() {
    this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', String(i === this.index)));
  }
}
if (!customElements.get('sc-banners')) customElements.define('sc-banners', SCBanners);
